<template>
  <div class="home">
    <section class="hero" id="hero">
      <div class="container">
        <h1>Ready to sculpt your body?</h1>
        <p>
          The dream of a perfect body is not out of reach anymore. With the best trainers and the best sports equipment, you will reach your dream vist us at <span>GYMPO</span> gym. There are many branches around you
        </p>
        <div class="btns">
          <a href="#"><span>contact us</span></a>
          <a href="#"><i class="fa-solid fa-location-dot"></i></a>
          <a href="#"><span>about us</span></a>
        </div>
        <div class="img">
          <img src="../assets/imgs/hero.jpg" alt="">
        </div>
      </div>
    </section>

    <div class="nav-gap" id="classes"></div>
    <h1 class="sec-head">Classes</h1>

    <section class="classes">
      <div class="head">
        <span>chose</span>
        <span>your</span>
        <span>fav</span>
      </div>
      <div class="slider">
        <classesSlider />
      </div>
    </section>

    <h1 class="sec-head">Our trainers</h1>
          
    <section class="trainers">
      <div class="container">
        <trainersSlider />
      </div>
    </section>

    <div class="nav-gap" id="prices"></div>
    <h1 class="sec-head">Our plans</h1>
          
    <section class="plans">
      <div class="container">
        <div class="plan-2">
          <h1 class="title">Best deal!</h1>
          <div class="head">
            <h3>Monthly</h3>
            <button @click="setNewDistancePlan2(50); setNewPricePlan2()"><span
                :style="{ left: distance_plan2 + '%' }"></span></button>
        
            <h3>Yearly</h3>
          </div>
          <h1 class="price">{{ price_plan2 }}$</h1>
          <ul>
            <li>Gym equipment</li>
            <li>groups coach</li>
            <li>personal trainer</li>
            <li>medical care</li>
            <li>Food Supplements</li>
          </ul>
          <a @click.prevent href="">Subscribe</a>
        </div>

        <div class="plan-1">
          <div class="head">
            <h3>Monthly</h3>
            <button @click="setNewDistancePlan1(50); setNewPricePlan1()"><span :style="{ left: distance_plan1 + '%' }"></span></button>
            <h3>Yearly</h3>
          </div>
          <h1 class="price">{{ price_plan1 }}$</h1>
          <ul>
            <li>Gym equipment</li>
            <li>groups coach</li>
            <li>personal trainer</li>
            <li>medical care</li>
            <li>Food Supplements</li>
          </ul>
          <a @click.prevent href="">Subscribe</a>
        </div>
        <div class="plan-3">
          <div class="head">
            <h3>Monthly</h3>
            <button @click="setNewDistancePlan3(50); setNewPricePlan3()"><span :style="{ left: distance_plan3 + '%' }"></span></button>
            <h3>Yearly</h3>
          </div>
          <h1 class="price">{{ price_plan3 }}$</h1>
          <ul>
            <li>Gym equipment</li>
            <li>groups coach</li>
            <li>personal trainer</li>
            <li>medical care</li>
            <li>Food Supplements</li>
          </ul>
          <a @click.prevent href="">Subscribe</a>
        </div>
      </div>
    </section>
  
    <div class="nav-gap" id="transformations"></div>
    <h1 class="sec-head" id="trans">Transformations</h1>

    <section class="transformations">
      <div class="container">
        <div>
          <h1>4.5 Months</h1>
          <div class="img"><img src="../assets/imgs/trans-1-before.jpg" alt=""></div>
          <div class="img"><img src="../assets/imgs/trans-1-after.jpg" alt=""></div>
        </div>
        <div>
          <h1>3 Months</h1>
          <div class="img"><img src="../assets/imgs/trans-2-before.jpg" alt=""></div>
          <div class="img"><img src="../assets/imgs/trans-2-after.jpg" alt=""></div>
        </div>
        <div>
          <h1>2 Years</h1>
          <div class="img"><img src="../assets/imgs/trans-3-before.jpg" alt=""></div>
          <div class="img"><img src="../assets/imgs/trans-3-after.jpg" alt=""></div>
        </div>
        <a href="https://www.instagram.com/" target="_blank" class="instagram"><i class="fa-brands fa-instagram"></i> GIMPO</a>
      </div>
    </section>

    <h1 class="sec-head" id="book">its <span>your turn</span> to make difference in your life!</h1>

    <section class="book">
      <div class="container">
        <form action="">
          <textarea placeholder="notes"></textarea>
          <input type="text" placeholder="age">
          <input type="text" placeholder="weight">
          <input type="text" placeholder="height">
          <input type="text" placeholder="class">
          <input type="text" placeholder="sex">
          <input type="submit" value="Book">
        </form>
      </div>
    </section>

    <footer>
      <div class="container">
        <a href="" @click.prevent><i class="fa-brands fa-whatsapp"></i></a>
        <ul>
          <li>
            <ul>
              <a href="" @click.prevent><li>contact us</li></a>
              <a href="" @click.prevent><li>about us</li></a>
              <a href="" @click.prevent><li>our branches</li></a>
              <a href="" @click.prevent><li>privacy</li></a>
            </ul>
          </li>
          <li>
            <ul>
              <li>all rights reserved - YK © 2022</li>
            </ul>
          </li>
        </ul>
        <a href="" @click.prevent><i class="fa-brands fa-instagram"></i></a>
      </div>
    </footer>
  </div>
</template>

<script>
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

import classesSlider from '@/components/classesSlider.vue';
import trainersSlider from '@/components/trainersSlider.vue';

export default {
  name: 'HomeView',
  data() {
    return {
      distance_plan1: 0,
      distance_plan2: 0,
      distance_plan3: 0,
      price_plan1: 30,
      price_plan2: 60,
      price_plan3: 20,
    }
  },
  components: {
    classesSlider,
    trainersSlider,
  },
  methods: {
    setNewDistancePlan1(x) {
      this.distance_plan1 = this.distance_plan1 == 0 ? x : 0
    },
    setNewDistancePlan2(x) {
      this.distance_plan2 = this.distance_plan2 == 0 ? x : 0
    },
    setNewDistancePlan3(x) {
      this.distance_plan3 = this.distance_plan3 == 0 ? x : 0
    },
    setNewPricePlan1() {
      this.price_plan1 = this.price_plan1 < 100 ? this.price_plan1 * 12 : this.price_plan1 / 12
    },
    setNewPricePlan2() {
      this.price_plan2 = this.price_plan2 < 100 ? this.price_plan2 * 12 : this.price_plan2 / 12
    },
    setNewPricePlan3() {
      this.price_plan3 = this.price_plan3 < 100 ? this.price_plan3 * 12 : this.price_plan3 / 12
    }
  }, mounted() {
      $(function() {
        $('.plans .head button').on('click', function () {
          $(this).parent().toggleClass('YearTrue')
        })

        $(window).on('scroll onload', function () {
          let links = ['classes', 'prices', 'transformations'];
          if ($(this).scrollTop() >= $('#hero').offset().top - $(window).height() / 2) {
            $('nav ul a').removeClass('active')
          }
          for (let i = 0; i < links.length; i++) {
            if ($(this).scrollTop() >= $('#' + links[i]).offset().top - $(window).height() / 2) {
              $('.' + links[i] + '-link').addClass('active')
              $('.' + links[i] + '-link').siblings().removeClass('active')
            } else if ($(this).scrollTop().prev >= $('#' + links[i]).offset().top - $(window).height() / 2) {
              $('.' + links[i] + '-link').prev.addClass('active')
              $('.' + links[i] + '-link').prev.siblings().removeClass('active')
            }
          }
        });

      })
  },
}
</script>
